import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import SkillApi from '../server/SkillApi';

function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            Dispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            Dispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);

export default {

    getAll: (params) => {
        const types = {
            success:    ActionTypes.SKILL_LIST,
            failure:    ActionTypes.SKILL_LIST_ERROR,
        };
        return Dispatcher.dispatchAsync(SkillApi.getAll(params), types);
    },

    getById: (id) => {
        const types = {
            success: ActionTypes.SKILL_INFO,
            failure: ActionTypes.SKILL_INFO_ERROR
        };
        return Dispatcher.dispatchAsync(SkillApi.getById(id), types, {id});
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.SKILL_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.SKILL_INFO_ERROR);

        return SkillApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.SKILL_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.SKILL_UPDATE_ERROR);

        return SkillApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    delete: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.SKILL_DELETE);
        const handleError = createErrorHandler(ActionTypes.SKILL_DELETE_ERROR);

        return SkillApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    search: function(searchText) {
        const types = {
            request:    ActionTypes.SEARCH_REQUEST,
            success:    [ActionTypes.SEARCH_SUCCESS, ActionTypes.SEARCH_RESULT_RECEIVED],
            failure:    [ActionTypes.SEARCH_FAILURE, ActionTypes.SEARCH_ERROR]
        };

        Dispatcher.dispatchAsync(SkillApi.search(searchText), types, {searchText});
    },

    getLevelOptions: function() {
        const handleSuccess = createSuccessHandler(ActionTypes.SKILL_LEVEL_OPTION_LIST);
        const handleError = createErrorHandler(ActionTypes.SKILL_INFO_ERROR);

        return SkillApi.getLevelOptions()
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },
    getTypeOptions: function() {
        const handleSuccess = createSuccessHandler(ActionTypes.SKILL_TYPE_OPTION_LIST);
        const handleError = createErrorHandler(ActionTypes.SKILL_INFO_ERROR);

        return SkillApi.getTypeOptions()
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    getGroupOptions: function() {
        const handleSuccess = createSuccessHandler(ActionTypes.SKILL_GROUP_OPTION_LIST);
        const handleError = createErrorHandler(ActionTypes.SKILL_INFO_ERROR);

        return SkillApi.getGroupOptions()
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

};
